export var ROOT_MENU = 'root';
export var SEARCH_FOCUS_DELAY = 100;
//# sourceMappingURL=constants.js.map